"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _reactFinalForm = require("react-final-form");

var _qs = _interopRequireDefault(require("qs"));

var _reactI18next = require("react-i18next");

var _rcSelect = _interopRequireDefault(require("rc-select"));

var _CompanyDictionary = require("../../context/CompanyDictionary");

var _i18n = require("../../utils/i18n");

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};

var Select = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Select, _Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Select);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDictionary", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dictionaryId, parentId) {
        var _this$props$settings, parentType, parent, isDictionaryLink, _this$props, apiUrl, field, changeContextOptions, urlParams, response, responseData, dictionaryKey, data;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props$settings = _this.props.settings, parentType = _this$props$settings.parentType, parent = _this$props$settings.parent;
                isDictionaryLink = parentType === 'parent';

                if (_this.state.loading) {
                  _context.next = 26;
                  break;
                }

                _this$props = _this.props, apiUrl = _this$props.apiUrl, field = _this$props.field, changeContextOptions = _this$props.changeContextOptions;

                _this.setState({
                  loading: true,
                  error: false
                });

                urlParams = isDictionaryLink ? _qs["default"].stringify({
                  filter: {
                    dictionary: dictionaryId,
                    parent: parent
                  },
                  pagination: JSON.stringify({
                    limit: 0
                  }),
                  relations: ['parent']
                }, {
                  addQueryPrefix: true
                }) : _qs["default"].stringify({
                  filter: {
                    dictionary: dictionaryId,
                    parent: Array.isArray(parentId) ? undefined : parentId,
                    parents: Array.isArray(parentId) ? parentId : undefined
                  },
                  pagination: JSON.stringify({
                    limit: 0
                  }),
                  relations: ['parent']
                }, {
                  addQueryPrefix: true
                });
                _context.prev = 6;
                _context.next = 9;
                return fetch("".concat(apiUrl || '', "/api/company-dictionary-item").concat(urlParams));

              case 9:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 12;
                  break;
                }

                throw new Error();

              case 12:
                _context.t0 = _ramda.propOr;
                _context.t1 = [];
                _context.next = 16;
                return response.json();

              case 16:
                _context.t2 = _context.sent;
                responseData = (0, _context.t0)(_context.t1, 'items', _context.t2);
                dictionaryKey = parentId || dictionaryId;
                data = responseData.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    value: item.id,
                    label: item.value
                  });
                });

                _this.setState({
                  options: (0, _defineProperty2["default"])({}, dictionaryKey, data),
                  loading: false
                }, function () {
                  return changeContextOptions && changeContextOptions(field, data);
                });

                _context.next = 26;
                break;

              case 23:
                _context.prev = 23;
                _context.t3 = _context["catch"](6);

                _this.setState({
                  loading: false,
                  error: true
                });

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 23]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (value) {
      var _this$props2 = _this.props,
          settings = _this$props2.settings,
          onChange = _this$props2.onChange,
          field = _this$props2.field,
          _this$props2$form = _this$props2.form,
          batch = _this$props2$form.batch,
          change = _this$props2$form.change,
          changeContextOptions = _this$props2.changeContextOptions,
          input = _this$props2.input;
      var multiple = (0, _ramda.path)(['multiple'], settings);

      if (value) {
        if (multiple) {
          onChange(value && value.length ? value : undefined);
        } else {
          var userValueQuestion = _this.getUserValueQuestion().value;

          onChange(_this.allowUserValue() && value === userValueQuestion ? undefined : value);
          _this.allowUserValue() && _this.setState({
            other: value === userValueQuestion
          });
        }
      }

      if (!value || !!value && value !== input.value) {
        var childs = _this.getFieldChilds();

        var fieldsForCleaning = !value ? [field].concat((0, _toConsumableArray2["default"])(childs)) : childs;
        var mutateValue = _this.props.form.mutators.mutateValue;
        batch(function () {
          fieldsForCleaning.forEach(function (fieldName) {
            change(fieldName, undefined);
          });
        });
        fieldsForCleaning.forEach(function (fieldName) {
          changeContextOptions(fieldName, undefined);
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeOther", function (e) {
      _this.props.onChange(e.target.value ? {
        value: 'Иное',
        userValue: e.target.value
      } : undefined);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "allowUserValue", function () {
      return _this.props.settings.userValueAllowed && !_this.props.settings.multiple;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserValueQuestion", function () {
      var value = _this.props.settings.userValueQuestion || _this.props.t('otherOption');

      return {
        label: value,
        value: value
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOptions", function () {
      var _this$props3 = _this.props,
          language = _this$props3.language,
          settings = _this$props3.settings,
          parentField = _this$props3.parentField,
          parentFieldValue = _this$props3.parentFieldValue,
          contextOptions = _this$props3.contextOptions;
      var parentFieldOptions = (0, _ramda.prop)(parentField, contextOptions);
      var dictionaryKey = settings.parent || settings.dictionary;
      var options = parentField && !(0, _ramda.isEmpty)(parentFieldOptions) ? (0, _ramda.pathOr)([], ['options', parentFieldValue], _this.state) : (0, _ramda.pathOr)([], ['options', dictionaryKey], _this.state);
      var filteredOptions = (0, _ramda.filter)((0, _ramda.allPass)([function (item) {
        if (settings.selection && settings.selection.length) {
          return (0, _ramda.contains)(item.value, settings.selection);
        } else {
          return true;
        }
      }]), options);
      return (_this.allowUserValue() ? [].concat((0, _toConsumableArray2["default"])(filteredOptions), [_this.getUserValueQuestion()]) : filteredOptions).map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          label: (0, _i18n.translateOptionLabel)(option, language)
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getParentOptions", function () {
      var _this$props4 = _this.props,
          contextOptions = _this$props4.contextOptions,
          parentField = _this$props4.parentField;
      return (0, _ramda.prop)(parentField, contextOptions);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDisableStatus", function () {
      var parentOptions = _this.getParentOptions();

      if (_this.props.parentField) {
        return parentOptions && (0, _ramda.isEmpty)(parentOptions) ? false : !_this.props.parentFieldValue;
      } else {
        return false;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getFieldChilds", function () {
      var _this$props5 = _this.props,
          fields = _this$props5.fields,
          field = _this$props5.field;
      var childs = [];
      var currentFields = [field];

      var findChilds = function findChilds(fieldName) {
        return (0, _ramda.filter)((0, _ramda.pathEq)(['settings', 'parentField'], fieldName), fields);
      };

      while (!(0, _ramda.isEmpty)(currentFields)) {
        currentFields.forEach(function (fieldName) {
          var childsFields = findChilds(fieldName);

          if (!(0, _ramda.isEmpty)(childsFields)) {
            childsFields.forEach(function (_ref2) {
              var field = _ref2.field;
              childs.push(field);
              currentFields.push(field);
              currentFields = (0, _ramda.filter)(function (currentFieldName) {
                return currentFieldName !== fieldName;
              }, currentFields);
            });
          } else {
            currentFields = [];
          }
        });
      }

      return childs;
    });
    _this.state = {
      options: {},
      loading: false,
      error: false,
      other: props.settings.userValueAllowed && !props.settings.multiple && props.input.value === (props.settings.userValueQuestion || 'Другое')
    };
    return _this;
  }

  (0, _createClass2["default"])(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props6 = this.props,
          settings = _this$props6.settings,
          parentField = _this$props6.parentField;
      !parentField && this.getDictionary(settings.dictionary, settings.parent);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props7 = this.props,
          settings = _this$props7.settings,
          parentType = _this$props7.settings.parentType,
          parentField = _this$props7.parentField,
          parentFieldValue = _this$props7.parentFieldValue,
          contextOptions = _this$props7.contextOptions,
          field = _this$props7.field,
          fieldsWithoutValidation = _this$props7.fieldsWithoutValidation,
          changeFieldValidation = _this$props7.changeFieldValidation,
          required = _this$props7.required,
          toggleRequired = _this$props7.toggleRequired;
      var loading = this.state.loading;
      var isDictionaryLink = parentType === 'parent';

      if (parentField && !loading) {
        var dictionaryId = (0, _ramda.prop)('dictionary', settings);
        var options = parentFieldValue ? (0, _ramda.path)(['options', parentFieldValue], this.state) : (0, _ramda.path)(['options', dictionaryId], this.state);
        var parentFieldOptions = (0, _ramda.prop)(parentField, contextOptions);

        if (parentFieldValue) {
          !options && this.getDictionary(dictionaryId, parentFieldValue);
        } else {
          !options && (0, _ramda.isEmpty)(parentFieldOptions) && this.getDictionary(dictionaryId);
        }

        if (options && fieldsWithoutValidation[field] !== (0, _ramda.isEmpty)(options)) {
          changeFieldValidation(field, (0, _ramda.isEmpty)(options));
        }

        var newRequiredStatus = !(0, _ramda.isEmpty)(options);

        if (newRequiredStatus !== required) {
          toggleRequired(newRequiredStatus);
        }
      }

      if (isDictionaryLink) {
        var parent = this.props.settings.parent;

        var _options2 = (0, _ramda.path)(['options', parent], this.state);

        var _newRequiredStatus = !(0, _ramda.isEmpty)(_options2);

        if (_options2 && fieldsWithoutValidation[field] !== (0, _ramda.isEmpty)(_options2)) {
          if (_newRequiredStatus !== required) {
            toggleRequired(_newRequiredStatus);
          }

          changeFieldValidation(field, (0, _ramda.isEmpty)(_options2));
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          _this$props8$input = _this$props8.input,
          value = _this$props8$input.value,
          name = _this$props8$input.name,
          settings = _this$props8.settings,
          t = _this$props8.t,
          disabled = _this$props8.disabled;
      var multiple = (0, _ramda.path)(['multiple'], settings);
      var placeholder = (0, _ramda.path)(['placeholder'], settings) || null;
      var options = this.getOptions();
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "".concat(name, "-select")
      }, /*#__PURE__*/_react["default"].createElement(_rcSelect["default"], (0, _extends2["default"])({
        id: name,
        key: value,
        value: (this.allowUserValue() && this.state.other ? this.getUserValueQuestion().value : value) || undefined,
        options: options,
        onChange: this.onChange,
        mode: multiple ? 'multiple' : 'single',
        showSearch: options.length > 10,
        optionFilterProp: "label",
        notFoundContent: t('noOptionsMessage'),
        placeholder: placeholder,
        prefixCls: "jobot-forms-rc-select",
        disabled: disabled || this.getDisableStatus(),
        loading: this.state.loading,
        allowClear: true,
        showArrow: true,
        virtual: true
      }, this.state.error ? {
        open: false
      } : {})), this.allowUserValue() && this.state.other && /*#__PURE__*/_react["default"].createElement("input", {
        className: "input ".concat(styles.formInput),
        style: {
          marginTop: 10
        },
        value: (0, _ramda.pathOr)('', ['userValue'], value),
        onChange: this.onChangeOther
      }));
    }
  }]);
  return Select;
}(_react.Component);

var withParentField = function withParentField(WrappedComponent) {
  return /*#__PURE__*/function (_Component2) {
    (0, _inherits2["default"])(WithParentField, _Component2);

    var _super2 = _createSuper(WithParentField);

    function WithParentField() {
      (0, _classCallCheck2["default"])(this, WithParentField);
      return _super2.apply(this, arguments);
    }

    (0, _createClass2["default"])(WithParentField, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var settings = this.props.settings;
        var parentField = (0, _ramda.prop)('parentField', settings);
        return /*#__PURE__*/_react["default"].createElement(_CompanyDictionary.CompanyDictionaryContext.Consumer, null, function (_ref3) {
          var options = _ref3.options,
              changeOptions = _ref3.changeOptions;

          var renderComponent = function renderComponent(value) {
            return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
              parentField: parentField,
              parentFieldValue: value,
              contextOptions: options,
              changeContextOptions: changeOptions
            }, _this2.props));
          };

          return parentField ? /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
            name: parentField,
            subscription: {
              value: true
            }
          }, function (_ref4) {
            var value = _ref4.input.value;
            return renderComponent(value);
          }) : renderComponent();
        });
      }
    }]);
    return WithParentField;
  }(_react.Component);
};

var _default = (0, _withFieldWrapper["default"])(withParentField((0, _reactI18next.withTranslation)()(Select)));

exports["default"] = _default;